import { render, staticRenderFns } from "./CheckItem.vue?vue&type=template&id=b39829a4&scoped=true&"
import script from "./CheckItem.vue?vue&type=script&lang=js&"
export * from "./CheckItem.vue?vue&type=script&lang=js&"
import style1 from "./CheckItem.vue?vue&type=style&index=1&id=b39829a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39829a4",
  null
  
)

export default component.exports